import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Returns the `search` URL param as it was when the component mounted ('' when absent).
 * Read once, so typing in the grid's own search box never changes it or the URL.
 * @returns {string} The carried search term.
 */
export const useCarriedSearchTerm = () => {
    const [searchParams] = useSearchParams();
    const [term] = useState(() => searchParams.get('search') || '');
    return term;
};
